









































































import { Component, Provide, Vue, Prop } from 'vue-property-decorator';
import { EventBus } from '../../event-bus';
import { mapGetters } from 'vuex';
import axios from 'axios';
import Swal from 'sweetalert2';

@Component({
  props: ['donorIds', 'patientId', 'idds', 'isToWorkAllowed'],
})
export default class LrModal extends Vue {
  @Provide()
  parentValidator = this.$validator;

  labs: any[] = [];
  actions: any[] = [];

  laboratoryId: any = null;
  isSending: any = false;
  actionIds: any = null;
  additionalComment: any = '';

  @Prop()
  donorIds: any;
  
  @Prop()
  patientId: any;

  @Prop()
  isToWorkAllowed: any;

  openSendToLrModal() {      
    if (!this.isToWorkAllowed) {
      Swal(
        '',
        this.$t('Для отправки доноров в работу необходим статус пациента `Поиск донора`') + '',
        'info'
      );
    } else {
      EventBus.$emit('showThrobber');

      axios.get('/SendDonorsToLr').then((response) => {
        this.labs = response.data.labarotories;
        this.actions = response.data.actions;
        this.showModal();
        EventBus.$emit('hideThrobber');
      });
    }    
  }

  async sendToLr() {
    if (await this.$validator.validateAll()) {
      EventBus.$emit('showThrobber');
      this.isSending = true;
      axios
        .post('/SendDonorsToLr', {
          patientId: this.patientId,
          donorIds: this.donorIds,
          actionIds: [this.actionIds],
          laboratoryId: this.laboratoryId,
          additionalComment: this.additionalComment,
        })
        .then((result) => {
          if(result.data) {
            Swal(this.$t('Предупреждение') + '', result.data, 'warning');
          }
          this.$emit('sendedToLr');
          this.hideModal();
          this.isSending = false;
          EventBus.$emit('hideThrobber');
        })
        .catch((error) => {
          this.hideModal();
          this.isSending = false;
          EventBus.$emit('hideThrobber');
          EventBus.$emit('error', { msg: error.data });
        });
    }
  }

  showModal() {
    this.$root.$emit('bv::show::modal', 'send-donor-to-lr-modal');
  }

  hideModal() {
    this.$root.$emit('bv::hide::modal', 'send-donor-to-lr-modal');
  }
}
